import type { NavItem } from '~/shared/routing/createModuleNav';
import type { ModuleDefinition } from '~/shared/routing/types';

export const sortModulesByOrder = (
  modules: ModuleDefinition[],
  order: string[],
): ModuleDefinition[] => {
  if (order.length === 0) return modules;

  const orderMap = new Map(order.map((path, index) => [path, index]));
  return [...modules].sort((a, b) => {
    const aIndex = orderMap.get(a.path) ?? Number.MAX_SAFE_INTEGER;
    const bIndex = orderMap.get(b.path) ?? Number.MAX_SAFE_INTEGER;
    return aIndex - bIndex;
  });
};

export const sortSubsectionsByOrder = (
  items: NavItem[],
  order: string[],
): NavItem[] => {
  if (order.length === 0) return items;

  const orderMap = new Map(order.map((path, index) => [path, index]));
  return [...items].sort((a, b) => {
    const aIndex = orderMap.get(a.route.path) ?? Number.MAX_SAFE_INTEGER;
    const bIndex = orderMap.get(b.route.path) ?? Number.MAX_SAFE_INTEGER;
    return aIndex - bIndex;
  });
};
